export const createFileData = /* GraphQL */ `
  mutation CustomCreateFileData(
    $input: CreateFileDataInput!
    $condition: ModelFileDataConditionInput
  ) {
    createFileData(input: $input, condition: $condition) {
      id
      expirationDate
      dueDate
      issueDate
      fileName
      original {
        bucket
        region
        key
        level
        identityId
      }
      fileType
      fileRequirement
      fileCategory
      contentType
      processRequestID
      companyID
      sourceID
      ownerNationalID
      uploadDate
      uploaderID
      createdAt
      updatedAt
      uploaderEmployer {
        id
        firstname
        lastname
        slug
        avatar {
          original {
            bucket
            key
            level
            region
            identityId
          }
          squareThumbnails {
            image {
              bucket
              key
              level
              region
              identityId
            }
            size
          }
        }
      }
      uploaderForeignNational {
        id
        firstname
        lastname
        slug
        avatar {
          original {
            bucket
            key
            level
            region
            identityId
          }
          squareThumbnails {
            image {
              bucket
              key
              level
              region
              identityId
            }
            size
          }
        }
      }
      uploaderTeamMember {
        id
        firstname
        lastname
        slug
        avatar {
          original {
            bucket
            key
            level
            region
            identityId
          }
          squareThumbnails {
            image {
              bucket
              key
              level
              region
              identityId
            }
            size
          }
        }
      }
    }
  }
`;
export const updateFileData = /* GraphQL */ `
  mutation CustomUpdateFileData(
    $input: UpdateFileDataInput!
    $condition: ModelFileDataConditionInput
  ) {
    updateFileData(input: $input, condition: $condition) {
      id
      expirationDate
      durationOfStatus
      dueDate
      issueDate
      fileName
      original {
        bucket
        region
        key
        level
        identityId
      }
      fileType
      fileRequirement
      fileCategory
      contentType
      processRequestID
      companyID
      sourceID
      ownerNationalID
      uploadDate
      uploaderID
      createdAt
      updatedAt
      uploaderEmployer {
        id
        firstname
        lastname
        slug
        avatar {
          original {
            bucket
            key
            level
            region
            identityId
          }
          squareThumbnails {
            image {
              bucket
              key
              level
              region
              identityId
            }
            size
          }
        }
      }
      uploaderForeignNational {
        id
        firstname
        lastname
        slug
        avatar {
          original {
            bucket
            key
            level
            region
            identityId
          }
          squareThumbnails {
            image {
              bucket
              key
              level
              region
              identityId
            }
            size
          }
        }
      }
      uploaderTeamMember {
        id
        firstname
        lastname
        slug
        avatar {
          original {
            bucket
            key
            level
            region
            identityId
          }
          squareThumbnails {
            image {
              bucket
              key
              level
              region
              identityId
            }
            size
          }
        }
      }
    }
  }
`;
